import { isSectionShown, WEDDING } from "../data/content";

const LINKS = [
  { href: "#schedule", label: "Schedule" },
  { href: "#travel", label: "Travel" },
  { href: "#faq", label: "FAQ" },
  { href: "#rsvp", label: "RSVP" },
].filter((link) => isSectionShown(link.href.slice(1)));

export function Footer() {
  return (
    <footer className="footer">
      <div className="monogram footer__monogram" role="img" aria-label="Aimee and Benjamin monogram" />
      <p className="footer__names">
        {WEDDING.brideFirst} &amp; {WEDDING.groomFirst}
      </p>
      <p className="fine footer__where">
        {WEDDING.dateLabel} · {WEDDING.venueLine}
      </p>
      <div className="footer__links">
        {LINKS.map((link) => (
          <a key={link.href} href={link.href}>
            {link.label}
          </a>
        ))}
      </div>
      <p className="fine footer__credit">
        Map data ©{" "}
        <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noreferrer">
          OpenStreetMap
        </a>{" "}
        contributors
      </p>
    </footer>
  );
}
